module.exports = __webpack_public_path__ + "static/media/LOGO MEDYCON-NEGRO.7c04d764.png";